import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
    selector: 'app-moi-warning-modal',
    templateUrl: './moi-warning-modal.component.html',
    styleUrls: ['./moi-warning-modal.component.css']
})
export class MoiWarningModalComponent {

    @Input() quantity: number;
    @Input() moi: number;
    @Input() uom: string;

    constructor(public activeModal: NgbActiveModal) {}

    cancel(): void {
        this.activeModal.dismiss();
    }

    confirm(): void {
        this.activeModal.close(true);
    }
}
